module.exports = __webpack_public_path__ + "static/media/mobile-logo.09a43c04.svg";